import React from 'react';

const cn = (...classes) => {
  return classes.filter(Boolean).join(' ');
};

// Base Radio Component
const Radio = React.forwardRef(({ className, ...props }, ref) => {
  return (
      <input
        type="radio"
        className={cn('radio-base', className)}
        ref={ref}
        {...props}
      />
  );
});
Radio.displayName = "Radio";

// Radio Group Item (Container for radio + label)
const RadioGroupItem = React.forwardRef(({ 
  className, 
  children, 
  disabled, 
  ...props 
}, ref) => {
  return (
    <div
      ref={ref}
      className={cn('radio-group-item', disabled && 'disabled', className)}
      {...props}
    >
      {children}
    </div>
  );
});
RadioGroupItem.displayName = "RadioGroupItem";

// Radio Label Component
const RadioLabel = React.forwardRef(({ 
  className, 
  disabled, 
  ...props 
}, ref) => {
  return (
    <label
      ref={ref}
      className={cn('radio-label', disabled && 'disabled', className)}
      {...props}
    />
  );
});
RadioLabel.displayName = "RadioLabel";

// Radio Group Container
const RadioGroup = React.forwardRef(({ 
  className, 
  children, 
  ...props 
}, ref) => {
  return (
    <div
      ref={ref}
      role="radiogroup"
      className={cn('radio-group', className)}
      {...props}
    >
      {children}
    </div>
  );
});
RadioGroup.displayName = "RadioGroup";

export { Radio, RadioGroup, RadioGroupItem, RadioLabel };

// Usage Example Component
// components/salary-change-radio.jsx
const SalaryChangeRadio = ({
  value,
  onValueChange,
  futureDaysLabel,
  bothLabel,
  className
}) => {
  return (
    <RadioGroup className={className}>
      <RadioGroupItem>
        <Radio
          id="option1"
          name="salary-change"
          value="future-days"
          checked={value === "future-days"}
          onChange={(e) => onValueChange(e.target.value)}
        />
        <RadioLabel htmlFor="option1">
          {futureDaysLabel}
        </RadioLabel>
      </RadioGroupItem>

      <RadioGroupItem>
        <Radio
          id="option2"
          name="salary-change"
          value="both"
          checked={value === "both"}
          onChange={(e) => onValueChange(e.target.value)}
        />
        <RadioLabel htmlFor="option2">
          {bothLabel}
        </RadioLabel>
      </RadioGroupItem>
    </RadioGroup>
  );
};
